import axios from 'axios';
import authHeader from './auth-header';

export const authorizedAxios = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
});

authorizedAxios.interceptors.request.use(
  (config) => {
    config.headers = { ...config.headers, ...authHeader() };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
